import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Non_Drawn_Abstract = () => {
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/nondrawn/abstract`)
      .then((response) => {
        setData(response.data);
        calculateTotals(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch nominee data.");
        setLoading(false);
      });
  }, []);

  const calculateTotals = (rows) => {
    const totalObj = {
      non_1: 0,
      non_3: 0,
      non_6: 0,
    };

    rows.forEach(row => {
      Object.keys(totalObj).forEach(key => {
        totalObj[key] += row[key] || 0;
      });
    });

    setTotals(totalObj);
  };
const handleExcelDownload = async (status, distCode) => {
  try {
    const url = `${process.env.REACT_APP_URL}/api/nondrawn/district/excel?status=${status}&distCode=${distCode}`;
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    const statusNames = { 1: "non_drawn_1", 3: "non_drawn_3", 6: "non_drawn_6" };
    const filename = `${statusNames[status] || "non_drawn"}.xlsx`;

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed", error);
    alert("Download failed. Please try again.");
  }
};


  return (
    <div className="wrapper">
      <br/><br/>
   {loading && (
      <div style={{ textAlign: 'center' }}>
      <CircularProgress size={40} />
      </div>
                )}
      {/* {loading && <p>{CircularProgress}</p>} */}
      {error && <p align="center"  className="text-red-500">{error}</p>}

      {!loading && !error && data.length > 0 && (
        <>
          <table style={{ width: '80%', margin: '0 auto', borderCollapse: 'collapse' }}>
            <thead>
              <tr className="tableheader">
                <td colSpan={5} style={{ textAlign: "center", fontWeight: "bold" }}>Non Drawl Cards</td>
              </tr>
              <tr className="tableheader">
                <th>Sl.No</th>
                <th>District</th>
                <th>One Month</th>
                <th>Three Months</th>
                <th>Six Months</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td align="left">{row.distNameEn}</td>
                  <td align="right">
                        {row.non_1> 0 ? (
                            <span
                            style={{ color: "blue", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                                onClick={() => handleExcelDownload(1, row.distCode)}

                            >
                            {row.non_1}
                            </span>
                        ) : (
                            row.non_1
                        )}
                        </td>
                        <td align="right">
                        {row.non_3> 0 ? (
                            <span
                            style={{ color: "blue", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                                onClick={() => handleExcelDownload(3, row.distCode)}

                            >
                            {row.non_3}
                            </span>
                        ) : (
                            row.non_3
                        )}
                        </td>
                        <td align="right">
                        {row.non_6> 0 ? (
                            <span
                            style={{ color: "blue", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                               onClick={() => handleExcelDownload(6, row.distCode)}
                            >
                            {row.non_6}
                            </span>
                        ) : (
                            row.non_6
                        )}
                        </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="tableheader" style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>
                <td colSpan={2} align="center">Total</td>
                <td align="right">{totals.non_1}</td>
                <td align="right">{totals.non_3}</td>
                <td align="right">{totals.non_6}</td>
              </tr>
            </tfoot>
          </table>
        </>
      )}

      {!loading && !error && data.length === 0 && (
        <p align="center" className='response'>No data found</p>
      )}

      <br /><br /><br />
    </div>
  );
};

export default Non_Drawn_Abstract;
